import styled from 'styled-components'

/**
 * Exposes table elements
 */

export const Container = styled.div`
  display: table;
`

export const Row = styled.div`
  display: table-row;
`

export const Item = styled.div`
  display: table-cell;
`
